export default __webpack_public_path__ + "static/media/btnHTP.bdca3e96.png";